import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy, registerLocaleData } from '@angular/common';
/** config ng-zorro-antd i18n **/
import { NZ_I18N, en_US } from 'ng-zorro-antd/i18n';
import { NgxUiLoaderConfig, NgxUiLoaderModule, SPINNER } from 'ngx-ui-loader';
import {
	PERFECT_SCROLLBAR_CONFIG,
	PerfectScrollbarConfigInterface,
	PerfectScrollbarModule
} from 'ngx-perfect-scrollbar';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AuthLayoutComponent } from './layout/app-layout/auth-layout/auth-layout.component';
import { BreadcrumbsComponent } from './layout/breadcrumbs/breadcrumbs.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { ClickOutsideModule } from 'ng-click-outside';
import { CoreModule } from './core/core.module';
import { ErrorInterceptor } from './core/interceptor/error.interceptor';
import { FormsModule } from '@angular/forms';
import { HeaderComponent } from './layout/header/header.component';
import { JwtInterceptor } from './core/interceptor/jwt.interceptor';
import { MainLayoutComponent } from './layout/app-layout/main-layout/main-layout.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PageLoaderComponent } from './layout/page-loader/page-loader.component';
import { RightSidebarComponent } from './layout/right-sidebar/right-sidebar.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from './shared/shared.module';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { SplitLastPipe } from './admin/app-reports/split-last-pipe.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { fakeBackendProvider } from './core/interceptor/fake-backend';
import { default as localeEn } from '@angular/common/locales/en';

// import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
// import { MomentModule } from 'angular2-moment'; // optional, provides moment-style pipes for date formatting

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
	suppressScrollX: true,
	wheelPropagation: false
};

export function createTranslateLoader(http: HttpClient) {
	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

registerLocaleData(localeEn, 'en');



const ngxUiLoaderConfig: NgxUiLoaderConfig = {
	bgsColor: 'red',
	bgsOpacity: 0.5,
	bgsPosition: 'bottom-right',
	bgsSize: 60,
	bgsType: 'square-jelly-box',
	blur: 5,
	delay: 0,
	fastFadeOut: true,
	fgsColor: '#2f89b2',
	fgsPosition: 'center-center',
	fgsSize: 60,
	fgsType: 'double-bounce',
	gap: 24,
	logoPosition: 'center-center',
	logoSize: 120,
	logoUrl: '',
	masterLoaderId: 'master',
	overlayBorderRadius: '0',
	overlayColor: 'rgba(40, 40, 40, 0.8)',
	pbColor: 'red',
	pbDirection: 'ltr',
	pbThickness: 3,
	hasProgressBar: false,
	text: '',
	textColor: '#000000',
	textPosition: 'center-center',
	maxTime: -1,
	minTime: 300
};

@NgModule({
	declarations: [
		AppComponent,
		HeaderComponent,
		PageLoaderComponent,
		SidebarComponent,
		RightSidebarComponent,
		AuthLayoutComponent,
		MainLayoutComponent,
		//SplitLastPipe,
		BreadcrumbsComponent
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		HttpClientModule,
		PerfectScrollbarModule,
		ClickOutsideModule,
		MatProgressBarModule,
		MatProgressSpinnerModule,
		NgxSpinnerModule,
		MatSnackBarModule,
		NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
		// core & shared
		CoreModule,
		SharedModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: createTranslateLoader,
				deps: [ HttpClient ]
			}
		}),
		FormsModule
		// NgIdleKeepaliveModule.forRoot(),
		// MomentModule
	],
	schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
	providers: [
		{ provide: NZ_I18N, useValue: en_US },
		{ provide: LocationStrategy, useClass: HashLocationStrategy },
		{
			provide: PERFECT_SCROLLBAR_CONFIG,
			useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
		},
		{ provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
		fakeBackendProvider
	],
	entryComponents: [],
	bootstrap: [ AppComponent ]
})
export class AppModule {}
